<sl-radio-group #radioGroup [name]="name" [value]="value">
  <ng-content />
</sl-radio-group>
